import styled from "@mui/material/styles/styled";

const MainImgContainer = styled("div")`
  display: flex;
  justify-content: center;
`;

export default MainImgContainer;
